import React, { type ReactNode } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { useNumUnmappedColumnsIncluded } from '../../../controllers/import-state/selectors';
import messages from './messages';

export const useContent = () => {
	const { formatMessage } = useIntl();
	const [numUnmappedColumnsIncludedSelector] = useNumUnmappedColumnsIncluded();

	return {
		title: formatMessage(messages.titleStandard, { count: numUnmappedColumnsIncludedSelector }),
		description: formatMessage(messages.descriptionStandard, {
			b: (content: ReactNode) => <b>{content}</b>,
		}),
		nextButtonText: formatMessage(messages.excludeFromImport),
		cancelButtonText: formatMessage(messages.cancel),
	};
};
